import type { ChangeEvent } from 'react'
import { forwardRef, useEffect, useState } from 'react'
import type {
  BoxComponentProps,
  PasswordInputProps as MantinePasswordInputProps,
} from '@mantine/core'
import { Box, PasswordInput as MantinePasswordInput, rem } from '@mantine/core'
import { IconEye, IconEyeOff } from '@tabler/icons-react'

import classes from './PasswordInput.module.css'

type PasswordInputProps = MantinePasswordInputProps & {
  containerProps?: BoxComponentProps
}

export const PasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>(
  ({ containerProps, onChange, value, ...props }, ref) => {
    const [localValue, setLocalValue] = useState(value || '')

    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
      onChange?.(event)

      setLocalValue(event.currentTarget.value)
    }

    useEffect(() => {
      setLocalValue(value || '')
    }, [value])

    return (
      <Box {...containerProps}>
        <MantinePasswordInput
          ref={ref}
          className={classes.passwordInput}
          onChange={handleChange}
          radius={rem(8)}
          value={localValue}
          visibilityToggleIcon={({ reveal }) =>
            reveal ? (
              <IconEyeOff height={24} width={24} />
            ) : (
              <IconEye height={24} width={24} />
            )
          }
          {...props}
        />
      </Box>
    )
  },
)
